import React from "react";
import Chart from "react-apexcharts";
import { getAccommodationStatusData } from "../../../../services/event/dashboard/dashboardServices"; 
import { useState, useEffect } from "react";      


const  AccommodationChart = (props) => {
  const { startMonth, endMonth, subDomain } = props;

  const [chartData, setChartData] = useState({
    options: {},
    series: [
      {
        name: "",
        data: [],
      },
    ],
  });
  useEffect(() => {
      const fetchData = async () => {
        try {

          const response = await getAccommodationStatusData(
            {
              sub_domain: subDomain,
              fromDate:startMonth,
              toDate: endMonth,
            });
    
          console.log("Response accomodation :", response);
    
          // Ensure response contains the expected structure
          if (response && Array.isArray(response.series) && response.series.length > 0) {
              setChartData((prevData) => ({
                ...prevData,
              series: response.series.map((value) => (value)),
                options: {
                  ...prevData.options,
                  ...response.options,
                  fill: {
                    opacity: 0.2, 
                    colors: ["#e83e8c"], 
                  },
                  dataLabels: {
                    enabled: true,
                    style: {
                      fontSize: "12px",
                      colors: ["#e83e8c"], 
                    },
                  },
                  stroke: {
                    show: true,
                    colors: ["#e83e8c"], 
                    width: 2,
                  },
                },
              }));
            } else {
              console.error("Invalid or missing data in response:", response);
            }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
    
      fetchData();
    }, [startMonth,endMonth,subDomain]);

  return (
    <Chart options={chartData.options} series={chartData.series} type="radar" height={350}   />
  )
};

export default AccommodationChart;
